import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SEOHelmet = ({ 
  title, 
  description, 
  keywords,
  image = "https://rickmolenaar.me/images/rick_1024.jpg",
  canonicalUrl 
}) => {
  // Use useLocation hook unconditionally - this is the proper way
  const location = useLocation();
  
  // Create canonical URL based on current location if not provided
  const currentCanonicalUrl = canonicalUrl || `https://rickmolenaar.me${location.pathname}`;
  
  // Default title and description if not provided
  const defaultTitle = "Rick Molenaar - IT Management Consulting & Interim Engineering Leadership";
  const defaultDescription = "Interim CTO, VP Engineering & Strategic IT Consultant. Expert in tech organization design, engineering leadership transitions, and complex project delivery across fintech, energy & travel sectors.";
  const defaultKeywords = "interim CTO, interim VP engineering, engineering leadership, tech organization design, IT consulting, software engineering management, agile transformation, technical leadership transition, engineering team building, technology strategy";
  
  const finalTitle = title || defaultTitle;
  const finalDescription = description || defaultDescription;
  const finalKeywords = keywords || defaultKeywords;

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={finalKeywords} />
      <link rel="canonical" href={currentCanonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:url" content={currentCanonicalUrl} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta property="twitter:title" content={finalTitle} />
      <meta property="twitter:description" content={finalDescription} />
      <meta property="twitter:url" content={currentCanonicalUrl} />
      <meta property="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEOHelmet;